<template>
    <div>
        <b-modal
            id="modify-Keyword-popup"
            ref="modal"
            :title="titlePopup"
            size="sm"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            :hide-header-close="loading"
            no-close-on-esc
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-3"
                            label="Stop Words"
                            label-for="country-title"
                        >
                            <b-form-input
                                id="stop-word-id"
                                v-model="formData.keyword"
                                type="text"
                                autocomplete="no"
                                placeholder="Enter Stop Word"
                                name="stop_word"
                                :class="{
                                    'is-invalid': errors.has('Stop Word'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    /*
   |--------------------------------------------------------------------------
   | Component > props
   |--------------------------------------------------------------------------
   */
    props: {
        title: {
            type: String,
            default: null,
        },
        buttonText: {
            type: String,
            default: 'Create',
        },
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'selectedItem',
            'hidePopup',
            'dataSegmentId',
        ]),
        titlePopup() {
            return this.selectedItem
                ? 'Modify Stop Word' /*+ ' ' + this.formData.title*/
                : 'Add Stop Word'
        }, // End of titlePopup() method
        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        }, // End of buttonLabel() method
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            //console.log('value is', value)
            if (value !== null && value !== undefined) {
                //console.log('value', Object.assign(this.formData, value))
                Object.assign(this.formData, value)
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                dataSegmentId: null,
                keyword: null,
                type: 'stopWord',
            }
        }, // End of initializeFormData() method
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        async onSubmit() {
            this.formData.dataSegmentId = localStorage.getItem(
                'activeDataSegmentId'
            )
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    // //console.log('value is',this.threshold)
                    // this.$emit('click',this.threshold)
                    // this.$refs.modal.hide()
                    //console.log('FORMDATA', this.formData)
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    //console.log(error, 'There is an error on submit')
                }
            }
        }, // End of onSubmit() method
    }, // End of Component > watch
}
</script>
